(() => {
  const SOUND_URL = 'https://cdn.shopify.com/s/files/1/0602/8270/0004/files/skullmx.mp3?v=1780031728';

  const audio = new Audio(SOUND_URL);
  audio.preload = 'auto';
  audio.volume = 1.0;
  audio.playsInline = true;

  let lastPlay = 0;
  const COOLDOWN = 900; // evita repeticiones dobles muy seguidas

  // Pre-carga / "desbloquea" el audio después de la primera interacción del usuario
  const primeAudio = () => {
    try {
      audio.load();
    } catch (e) {}
    document.removeEventListener('pointerdown', primeAudio);
    document.removeEventListener('touchstart', primeAudio);
    document.removeEventListener('keydown', primeAudio);
  };

  document.addEventListener('pointerdown', primeAudio, { passive: true });
  document.addEventListener('touchstart', primeAudio, { passive: true });
  document.addEventListener('keydown', primeAudio, { passive: true });

  function setMediaSession() {
    if (!('mediaSession' in navigator) || typeof MediaMetadata === 'undefined') return;

    try {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: 'Termina tu compra con envio GRATIS. SKULL.MX"',
        artist: 'CUPÓN "SHIPFREE26"',
        album: 'CUPÓN "SHIPFREE26"',
        artwork: [
          {
            src: 'https://cdn.shopify.com/s/files/1/0602/8270/0004/files/Captura_de_pantalla_2026-05-28_a_la_s_10.14.05_p.m..png?v=1780028059',
            sizes: '512x512',
            type: 'image/png'
          }
        ]
      });
    } catch (e) {
      // Si no existe artwork o iOS no lo toma, no pasa nada
    }
  }

  function playCartSound() {
    const now = Date.now();
    if (now - lastPlay < COOLDOWN) return;
    lastPlay = now;

    try {
      setMediaSession();

      audio.pause();
      audio.currentTime = 0;

      const playPromise = audio.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    } catch (e) {}
  }

  // ===== Hook universal para fetch =====
  const originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      try {
        const requestUrl =
          typeof args[0] === 'string'
            ? args[0]
            : args[0] && args[0].url
            ? args[0].url
            : '';

        const isCartAdd =
          requestUrl.includes('/cart/add.js') ||
          requestUrl.includes('/cart/add');

        if (isCartAdd && response && response.ok) {
          playCartSound();
        }
      } catch (e) {}

      return response;
    };
  }

  // ===== Fallback para XHR por si algún script/app no usa fetch =====
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._cartSoundUrl = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      try {
        const url = this._cartSoundUrl || '';
        const isCartAdd =
          url.includes('/cart/add.js') ||
          url.includes('/cart/add');

        if (isCartAdd && this.status >= 200 && this.status < 300) {
          playCartSound();
        }
      } catch (e) {}
    });

    return originalSend.apply(this, args);
  };
})();